var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionWarningLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -644.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Warning/Large",
    transform: "translate(445.000000, 644.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,30 C8.268,30 2,23.731 2,16 C2,8.268 8.268,2 16,2 C23.733,2 30,8.268 30,16 C30,23.731 23.733,30 16,30 L16,30 Z M16,0 C24.837,0 32,7.163 32,16 C32,24.836 24.837,32 16,32 C7.164,32 0,24.836 0,16 C0,7.163 7.164,0 16,0 Z M22.4333333,21.4 L9.63333333,21.4 L9.63333333,23 L22.4333333,23 L22.4333333,21.4 Z M16.0333333,11.2666667 C13.3821333,11.2666667 11.2333333,13.4154667 11.2333333,16.0666667 L11.2333333,16.0666667 L11.2333333,20.3333333 L20.8333333,20.3333333 L20.8333333,16.0666667 C20.8333333,13.4154667 18.6845333,11.2666667 16.0333333,11.2666667 Z M14.9666667,13.4 L14.9666667,16.6 C14.9666667,17.7781333 14.0114667,18.7333333 12.8333333,18.7333333 L12.8333333,18.7333333 L12.8333333,15.5333333 C12.8333333,14.3552 13.7885333,13.4 14.9666667,13.4 L14.9666667,13.4 Z M24.5666667,14.4666667 L22.4333333,14.4666667 L22.4333333,15.5333333 L24.5666667,15.5333333 L24.5666667,14.4666667 Z M9.63333333,14.4666667 L7.5,14.4666667 L7.5,15.5333333 L9.63333333,15.5333333 L9.63333333,14.4666667 Z M10.6322667,8.92693333 L9.80613333,9.60213333 L11.1565333,11.2538667 L11.9821333,10.5786667 L10.6322667,8.92693333 Z M21.4349333,8.92693333 L20.0845333,10.5786667 L20.9101333,11.2538667 L22.2605333,9.60213333 L21.4349333,8.92693333 Z M16.5666667,7 L15.5,7 L15.5,9.13333333 L16.5666667,9.13333333 L16.5666667,7 Z",
    id: 233
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionWarningLarge);
export default __webpack_public_path__ + "static/media/navigation-and-action-warning-large.16ac19c4.svg";
export { ForwardRef as ReactComponent };